module.exports = __webpack_public_path__ + "img/06.267b3aec.png";